import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/components/home/Home'
import Automations from '@/components/home/Automations'
import AutomationsCampaigns from '@/components/home/AutomationsCampaigns'
import AdminPages from '@/components/admin/AdminPages'
import DownloadsPages from '@/components/downloads/DownloadsPages'
import LogPages from '@/components/logs/LogPages'
import Auth from '@/components/auth/Auth'
import TReportsPages from '@/components/researches/TReportsPages'
import ConsultPages from '@/components/consult/ConsultPages'
import formTReports from '@/components/public/forms/TReports'
import formConsult from '@/components/public/forms/Consult'

import { userKey } from '@/global'

Vue.use(VueRouter)

const routes = [
    {
        name: 'home',
        path: '/',
        component: Home,
        meta: { requiresAdmin: true },
        props: true
    },
    {
        name: 'automations',
        path: '/automations',
        component: Automations,
        meta: { requiresAdmin: true },
        props: true
    },
    {
        name: 'automationsCampaigns',
        path: '/automations/:id/campaigns',
        component: AutomationsCampaigns,
        meta: { requiresAdmin: true },
        props: true
    },
    {
        name: 'downloadsPages',
        path: '/downloads',
        component: DownloadsPages,
        meta: { requiresAdmin: true }
    },
    {
        name: 'adminPages',
        path: '/admin',
        component: AdminPages,
        meta: { requiresAdmin: true }
    },
    {
        name: 'logsPages',
        path: '/logs',
        component: LogPages,
        meta: { requiresAdmin: true },
        props: true
    },
    {
        name: 'logsPagesId',
        path: '/logs/:_id',
        component: LogPages,
        meta: { requiresAdmin: true },
        props: true
    },
    {
        name: 'auth',
        path: '/auth',
        component: Auth
    },
    {
        name: 'TReportsPages',
        path: '/researches/treports',
        component: TReportsPages,
        meta: { requiresAdmin: true }
    },
    {
        name: 'ConsultPages',
        path: '/consult',
        component: ConsultPages,
        meta: { requiresAdmin: true }
    },
    {
        name: 'formTReports',
        path: '/public/forms/treports',
        component: formTReports,
        props: (route) => ({ query: route.query.email })
    },
    {
        name: 'formConsult',
        path: '/public/forms/consult',
        component: formConsult,
        props: (route) => ({ query: route.query.course })
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    const json = localStorage.getItem(userKey)
    
    if(to.matched.some(record => record.meta.requiresAdmin)) {
        const user = JSON.parse(json)
        user && user.admin ? next() : next({ path: '/' })
    } else {
        next()
    }
})

export default router
